module.exports = __webpack_public_path__ + "img/card1.832364be.png";